"use client";

import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";

const TotalSales = ({ data }) => {
  const [Chart, setChart] = useState();

  useEffect(() => {
    import("react-apexcharts").then((mod) => {
      setChart(() => mod.default);
    });
  }, []);

  //  Temporary static graph (replace later with backend trend)
  const series = [
    {
      name: "Worked Hours",
      data: [3, 7, 7, 10, 9, 7, 20],
    },
  ];

  const options = {
    chart: {
      zoom: { enabled: false },
      toolbar: { show: false },
    },
    colors: ["#4936F5"],
    dataLabels: { enabled: false },
    grid: { show: false },
    stroke: { curve: "straight", width: 1 },
    xaxis: {
      categories: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      labels: { show: false },
    },
    yaxis: { show: false },
  };

  //  Main value
  const hours = data ? Math.round(data.today / 3600) : "--";

  //  Comparison
  const change = data?.change_week || 0;
  const isUp = change >= 0;

  return (
    <Card className="border bg-white rounded-3 overflow-hidden mb-4">
      
      {/* Top Section */}
      <div className="d-flex align-items-center p-4 pb-3 mb-1">
        <div className="flex-shrink-0">
          <div
            className="wh-55 bg-primary bg-opacity-25 text-center rounded-2"
            style={{ lineHeight: "55px" }}
          >
            <i className="ri-time-line fs-22 bg-primary text-white rounded-2 p-2"></i>
          </div>
        </div>

        <div className="flex-grow-1 ms-3">
          <h3 className="fs-24 fw-medium mb-0">
            {hours !== "--" ? `${hours} H` : "--"}
          </h3>
          <span>Total Worked Hours</span>
        </div>
      </div>

      {/* Comparison */}
      <div className="d-flex align-items-center p-4 pb-0">
        <span
          className={`d-inline-block ${
            isUp
              ? "bg-success text-success border-success"
              : "bg-danger text-danger border-danger"
          } bg-opacity-10 border rounded-pill px-2 fw-medium d-flex align-items-center fs-12`}
        >
          <i className={`ri-arrow-${isUp ? "up" : "down"}-fill fs-14 lh-1`}></i>
          {Math.abs(change)}%
        </span>

        <span className="ms-2 fs-12">from last week</span>
      </div>

      {/* Chart */}
      <div style={{ margin: "-45px -11px -31px -15px" }}>
        {Chart && (
          <Chart
            options={options}
            series={series}
            type="area"
            height={120}
          />
        )}
      </div>
    </Card>
  );
};

export default TotalSales;